module.exports = __webpack_public_path__ + "static/img/1.28840dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news19/1.png
// module id = jDfA
// module chunks = 1